export default "__VITE_ASSET__2Kuq147C__"